import React from 'react';
import { navigate } from 'gatsby';
import classnames from 'classnames';
import { useWindowWidth } from '@react-hook/window-size/throttled';

import Icon from 'components/ui/Icon';
import Tags from 'components/partials/Tags';
import ShareSocials from '../ShareSocials';

import { link, rounded, text } from './styles.module.scss';

const AsideInfo = ({ authors, tags, uri, title, excerpt }) => {
  const windowWidth = useWindowWidth({ initialWidth: 1024 });

  return (
    <div className="sm:mt-16 sm:justify-between sm:space-x-6 sm:flex lg:block lg:space-x-0 lg:mt-0">
      {windowWidth > 1024 ? (
        <div className="mb-16">
          <button
            type="button"
            className={classnames(
              link,
              'inline-flex justify-start items-center',
            )}
            onClick={() => navigate(-1)}
          >
            <span
              className={classnames(
                rounded,
                'mr-5 p-4 w-16 h-16 inline-flex justify-center items-center flex-shrink-0	 border border-mine-shaft rounded-full overflow-hidden',
              )}
            >
              <Icon name="arrow-left" className=" w-7 h-7 " />
            </span>

            <span className={classnames(text)}>Back</span>
          </button>
        </div>
      ) : null}

      {authors && authors.length > 0 ? (
        <div className="mt-8 mb-4 pb-8 border-b border-mine-shaft sm:mt-0 sm:flex-3 sm:border-0  lg:mt-0 lg:pb-16 lg:mb-8 lg:border-b lg:border-mine-shaft">
          <p className="mb-4 oc-lead-2">Authors</p>

          {authors.map((author, i) => (
            <p key={i} className="mb-2 oc-small uppercase">
              {author?.guideArticleTextAuthorsAuthor
                ? author?.guideArticleTextAuthorsAuthor
                : author?.articlePostAuthorsAuthor}
            </p>
          ))}
        </div>
      ) : null}

      {tags?.nodes.length > 0 ? (
        <div className="mt-8 mb-4 pb-8 border-b border-mine-shaft sm:mt-0 lg:mt-0 sm:border-0  lg:pb-16 lg:mb-8 lg:border-b lg:border-mine-shaft">
          <p className="mb-4 oc-lead-2">Tags</p>

          <Tags tags={tags.nodes} />
        </div>
      ) : null}

      <div className="mb-4 pb-7 sm:mb-0 sm:pb-0 lg:pb-14 ">
        <p className="mb-4 oc-lead-2">Share</p>

        <ShareSocials uri={uri} title={title} excerpt={excerpt} />
      </div>
    </div>
  );
};

export default AsideInfo;
